// extracted by mini-css-extract-plugin
module.exports = {"billing-footer":"billing-footer-35Hhk7J","space-right-button":"space-right-button-1FiBkFG","has-footer":"has-footer-9apYdec"};